import { Typography } from "@mui/material";
import {
  Card,
  CardDescription,
  CardTitle,
  CardHeader,
  CardContent,
} from "@/components/ui/card";
import { Box } from "@mui/material";
import { Separator } from "@/components/ui/separator";
import CompaniesTable from "@/components/companiesTable/page";

export const CompaniesPage = () => {
  return (
    <Box className="flex flex-col p-4 h-full">
      <Card className="w-full h-full gap-0">
        <CardHeader className="flex flex-col gap-0">
          <CardTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Compañias
            </Typography>
          </CardTitle>
          <CardDescription>
            <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
              Gestiona las compañias de la plataforma.
            </Typography>
          </CardDescription>
          <Separator className="w-full mt-4 mb-2" />
        </CardHeader>
        <CardContent>
          <CompaniesTable />
        </CardContent>
      </Card>
    </Box>
  );
};
